
import api from "./api";

export const tradeHistoryAPI = {
  async getHistory({ page = 1, limit = 10, startDate, endDate } = {}) {
    const params = { page, limit };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const res = await api.get("/arbitrage/history", { params });
    return res.data;
  },
};
